<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col>
        <LoadingSpinner :loading="loading" :text="$lang.sending_data" />
        <b-form-group
          v-if="!loading"
          class="mb-3 border-bottom pb-3"
          :label="`نحوه ورود اطلاعات: `"
          label-cols="12"
        >
          <b-form-radio-group
            class="mt-2"
            v-model="isUploadEXcel"
            :options="isUploadEXcelOptions"
            name="gender"
          />
        </b-form-group>
        <b-form @submit.prevent="save" v-show="!loading && !isUploadEXcel">
          <b-alert show variant="info">
            <i class="fas fa-info-circle fa-lg mr-1" />
            <b v-html="alertMessage" />
          </b-alert>
          <b-form-group
            :label="$lang.profileLang.select_term"
            label-for="term_selected"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.profileLang.select_term"
              :rules="$v.term_selected.$params"
            />
            <selectFind
              :options="term_options"
              v-model="$v.term_selected.$model"
              label="caption"
              id="code"
              :loading="term_loading"
              :isValid="
                $v.term_selected.$dirty ? !$v.term_selected.$error : null
              "
            />
            <b-form-invalid-feedback
              :style="{
                display: $v.term_selected.$error ? 'block' : 'none',
              }"
              id="term_selected_feedback"
            >
              {{
                $lang.error_required | replace($lang.profileLang.select_term)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            :label="$lang.name"
            label-for="name"
            :label-cols="this.$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.name"
              :rules="$v.name.$params"
            />
            <b-form-input
              id="name"
              type="text"
              autocomplete="off"
              v-model="$v.name.$model"
              :state="$v.name.$dirty ? !$v.name.$error : null"
            />

            <b-form-invalid-feedback
              v-if="!$v.name.required"
              id="name-feedback"
            >
              {{ $lang.error_required | replace($lang.name) }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            :label="$lang.family"
            label-for="family"
            :label-cols="this.$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.family"
              :rules="$v.family.$params"
            />
            <b-form-input
              id="family"
              v-model="$v.family.$model"
              :state="$v.family.$dirty ? !$v.family.$error : null"
              type="text"
              autocomplete="off"
            />
            <b-form-invalid-feedback
              v-if="!$v.family.required"
              id="family-feedback"
            >
              {{
                $lang.error_required | replace($lang.family)
              }}</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group
            :label="$lang.gender"
            label-for="gender_id"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.gender"
              :rules="$v.gender_selected.$params"
            />
            <selectFind
              :options="gender_options"
              v-model="$v.gender_selected.$model"
              label="text"
              :placeholder="` `"
              class="multiselect-form"
              :isValid="
                $v.gender_selected.$dirty ? !$v.gender_selected.$error : null
              "
            />

            <b-form-invalid-feedback
              :style="{
                display: $v.gender_selected.$error ? 'block' : 'none',
              }"
              id="gender_id-feedback"
            >
              {{
                $lang.error_required | replace($lang.gender)
              }}</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group
            :label="$lang.national_code"
            label-for="national_code"
            :label-cols="this.$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.national_code"
              :rules="$v.national_code.$params"
            />
            <b-form-input
              id="national_code"
              v-model="$v.national_code.$model"
              :state="$v.national_code.$dirty ? !$v.national_code.$error : null"
              type="text"
              autocomplete="off"
            />

            <div class="invalid-feedback" v-if="!$v.national_code.numeric">
              {{ $lang.error_numeric | replace($lang.national_code) }}
            </div>
            <div
              class="invalid-feedback"
              v-if="
                ($v.national_code.numeric && !$v.national_code.minLength) ||
                !$v.national_code.maxLength
              "
            >
              {{ $lang.error_max | replace($lang.national_code, 10) }}
            </div>
          </b-form-group>
          <b-alert show>
            <span class="mr-1"><mdicon name="information" /></span>
            <strong v-text="$lang.nationalCodeIsUsername" />
          </b-alert>
          <b-form-group
            :label="$lang.mobile"
            label-for="mobile"
            :label-cols="12"
          >
            <requiredComponent
              slot="label"
              :label="$lang.mobile"
              :rules="$v.mobile.$params"
            />
            <b-form-input
              type="text"
              maxLength="11"
              autocomplete="off"
              placeholder="مثال:09121112233 "
              :state="$v.mobile.$dirty ? !$v.mobile.$error : null"
              v-model="$v.mobile.$model"
            />
            <b-form-invalid-feedback id="mobile-feedback">
              <div v-if="!$v.mobile.required">
                {{ $lang.error_required | replace($lang.mobile) }}
              </div>
              <div v-if="$v.mobile.required && !$v.mobile.minLength">
                {{ $lang.error_length | replace($lang.mobile, 11) }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            :label="$lang.term_password"
            label-for="password"
            :label-cols="12"
          >
            <requiredComponent
              slot="label"
              :label="$lang.term_password"
              :rules="$v.password.$params"
            />
            <b-input-group>
              <b-form-input
                id="password"
                :type="showVisiblePassword ? 'text' : 'password'"
                :state="$v.password.$dirty ? !$v.password.$error : null"
                v-model="$v.password.$model"
                autocomplete="off"
              />
              <b-input-group-text
                @click.prevent="toggleShowVisibleNewPassword"
                style="cursor: pointer"
              >
                <a href="#">
                  <i
                    :class="
                      showVisiblePassword ? 'fa fa-eye' : 'fa fa-eye-slash'
                    "
                    aria-hidden="true"
                  />
                </a>
              </b-input-group-text>
              <b-form-invalid-feedback id="password-feedback">
                <div v-if="!$v.password.required">
                  {{ $lang.error_required | replace($lang.term_password) }}
                </div>
                <div v-if="$v.password.required && !$v.password.minLength">
                  {{ $lang.error_min_value | replace($lang.term_password, 8) }}
                </div>
              </b-form-invalid-feedback>
            </b-input-group>
            <small
              class="form-text text-info text-left"
              v-text="$lang.password_template"
            />
          </b-form-group>
          <b-form-group
            :label="$lang.confirm_term_password"
            label-for="password_confirmation"
            :label-cols="12"
          >
            <requiredComponent
              slot="label"
              :label="$lang.confirm_term_password"
              :rules="$v.password_confirmation.$params"
            />
            <b-input-group>
              <b-form-input
                id="password_confirmation"
                :type="showVisibleConfirmPassword ? 'text' : 'password'"
                :state="
                  $v.password_confirmation.$dirty
                    ? !$v.password_confirmation.$error
                    : null
                "
                v-model="$v.password_confirmation.$model"
                autocomplete="off"
              />
              <b-input-group-text
                @click.prevent="toggleShowVisibleConfirmNewPassword"
                style="cursor: pointer"
              >
                <a href="#">
                  <i
                    :class="
                      showVisibleConfirmPassword
                        ? 'fa fa-eye'
                        : 'fa fa-eye-slash'
                    "
                    aria-hidden="true"
                  />
                </a>
              </b-input-group-text>
              <b-form-invalid-feedback id="password_confirmation-feedback">
                <div v-if="!$v.password_confirmation.required">
                  {{
                    $lang.error_required | replace($lang.confirm_term_password)
                  }}
                </div>
                <div v-if="!$v.password_confirmation.minLength">
                  {{
                    $lang.error_min_value
                      | replace($lang.confirm_term_password, 8)
                  }}
                </div>
                <div
                  v-if="
                    !$v.password_confirmation.sameAs &&
                    $v.password_confirmation.minLength
                  "
                >
                  {{ $lang.error_sameAs | replace($lang.term_password) }}
                </div>
              </b-form-invalid-feedback>
            </b-input-group>
            <small
              class="form-text text-info text-left"
              v-text="$lang.password_template"
            />
          </b-form-group>
          <div slot="footer" class="form-group form-btn">
            <b-button
              type="submit"
              size="md"
              variant="success"
              v-if="isAdmin(parentPermissions)"
            >
              {{ $lang.submitButton }}
              <i class="fa fa-check"></i>
            </b-button>
            <b-button
              type="reset"
              class="ml-2"
              size="md"
              variant="danger"
              @click="$emit('closeModal')"
            >
              {{ $lang.cancelButton }}
              <i class="fa fa-ban"></i>
            </b-button>
          </div>
        </b-form>
        <ShowCardUpload
          v-if="isUploadEXcel"
          :url="uploadExcelUrl"
          :showAlert="exampleFileLink"
          @closeModal="$emit('closeModal')"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  required,
  numeric,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import ShowCardUpload from "@/components/fileManager/showCardUpload";
import { pathOr } from "ramda";
import { isAdmin, renderEumOptions, generateApiUrl } from "@/shared/utils";

export default {
  name: "add-term",
  validations: {
    term_selected: {
      required,
    },
    name: {
      required,
    },
    family: {
      required,
    },
    national_code: {
      required,
      numeric,
      minLength: minLength(10),
      maxLength: maxLength(10),
    },
    gender_selected: {
      required,
    },
    mobile: {
      required,
      numeric,
      minLength: minLength(11),
      maxLength: maxLength(11),
    },
    password: {
      required,
      minLength: minLength(8),
    },
    password_confirmation: {
      required,
      minLength: minLength(8),
      sameAs: sameAs("password"),
    },
  },
  components: {
    LoadingSpinner,
    ShowCardUpload,
  },
  props: {
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      isUploadEXcel: false,
      formType: false,
      term_options: [],
      term_selected: null,
      term_loading: false,
      name: null,
      family: null,
      national_code: null,
      gender_selected: null,
      mobile: null,
      password: null,
      password_confirmation: null,
      showVisiblePassword: false,
      showVisibleConfirmPassword: false,
      isUploadEXcelOptions: [
        { text: "ایجاد پرونده توسط کاربر", value: false },
        { text: "ایجاد پرونده از طریق بارگذاری فایل گروهی", value: true },
      ],
    };
  },
  computed: {
    gender_options() {
      return renderEumOptions("gender");
    },
    alertMessage() {
      return "امکان ثبت نام کاربر در یک دوره فعال بدون طی مراحل توسط خود کاربر توسط اپراتور سامانه با داشتن اطلاعات آیتم‌های ذیل میسر است مقتضی است صحت شماره همراه و تعلق داشتن به فرد در این حالت کنترل نشده و مسئولیت آن بعهده اپراتور ثبت کننده می باشد";
    },
    uploadExcelUrl() {
      return generateApiUrl(["profile", "excel_manual_register"]);
    },
    exampleFileLink() {
      const link = `${generateApiUrl(["resources", "upload_folder"], [], {}, [
        "server_url",
      ])}/import_term_parvandeh_data.xlsx`;
      return `<div class='text-center font-weight-bold'><a href='${link}'>جهت دانلود فایل نمونه کلیک کنید</a></div>`;
    },
  },
  created() {
    this.getTerms();
  },
  methods: {
    pathOr,
    isAdmin,
    renderEumOptions,
    generateApiUrl,
    async getTerms() {
      try {
        this.term_loading = true;
        const url = generateApiUrl(["profile", "term_combo"]);
        const response = await this.$httpService.get(url);
        this.term_options = pathOr([], ["data", "data"], response).map(
          (item) => {
            return {
              caption: `${pathOr("", ["id"], item)} - ${pathOr(
                "",
                ["caption"],
                item
              )}`,
              code: pathOr(null, ["code"], item),
            };
          }
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.term_loading = false;
      }
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      try {
        this.loading = true;
        const payload = {
          term_code: pathOr(null, ["code"], this.term_selected),
          name: this.name,
          family: this.family,
          gender_id: pathOr(null, ["value"], this.gender_selected),
          mobile: this.mobile,
          national_code: this.national_code,
          password: this.password,
          password_confirmation: this.password_confirmation,
        };
        const url = generateApiUrl(["profile", "form_manual_register"]);
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.$emit("closeModal");
        this.$emit("getData");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    updateRoleSelected(data) {
      this.roleSelected = data;
    },
    toggleShowVisibleNewPassword() {
      this.showVisiblePassword = !this.showVisiblePassword;
    },
    toggleShowVisibleConfirmNewPassword() {
      this.showVisibleConfirmPassword = !this.showVisibleConfirmPassword;
    },
  },
};
</script>
